import { defineStore } from 'pinia'

export const useWindowStore = defineStore('window', {
  state: () => {
    return {
      changedTime: 0,
      flag: 'window',
    }
  },
  actions: {
    setChangedTime(f) {
      this.flag = f
      this.changedTime = new Date().getTime()
    },
  },
})
